import { useDispatch } from 'react-redux';
import { useFieldArrayMethods } from '../../../../helpers/formManager';
import { fieldNames } from '../../shared/configs/acceptanceForm';
import { actionCreators, sliceKeys } from '../../model';
import { useEvent } from '../../../../hooks/useEvent';

const { activeDeskIndexChanged } = actionCreators[sliceKeys.desks];

export const useAddDeskToAcceptanceSetup = () => {
  const { append } = useFieldArrayMethods();

  const dispatch = useDispatch();

  return useEvent(() => {
    append(
      {
        [fieldNames.desk.name]: undefined,
        [fieldNames.desk.uniqueDateRange]: false,
        [fieldNames.desk.workingDays]: [],
      },
      ({ fieldCount }) => dispatch(activeDeskIndexChanged(fieldCount - 1))
    );
  });
};
